module.exports = __webpack_public_path__ + "static/media/pr-sequences-for-landing.3089cc95.svg";